﻿

(() => {
    angular.module("fliptoWeb")
        .animation(".more-animate", [
            () => {
                return {
                    enter: (element, done) => {
                        var tl = new TimelineLite({ onComplete: done });

                        tl.from(element, .3, { opacity: 0, scale: .5, transformOrigin: "46px -15px", ease: Power4.easeInOut });

                        return (cancelled) => {
                            //this (optional) function will be called when the animation
                            //completes or when the animation is cancelled (the cancelled
                            //flag will be set to true if cancelled).
                        }
                    },

                    leave: (element, done) => {
                        var tl = new TimelineLite({ onComplete: done });
                        tl.to(element, .3, { opacity: 0, scale: .5, transformOrigin: "46px -15px", display: "none", ease: Power4.easeInOut });

                        return (cancelled) => {
                            //this (optional) function will be called when the animation
                            //completes or when the animation is cancelled (the cancelled
                            //flag will be set to true if cancelled).
                        }
                    }
                }
            }
        ]);
})()
